import axios from "axios"
import React, { useState } from "react"
import CustomFileInput from "../Atoms/CustomFileInput"
import AppToaster from "utils/AppToaster"
import { Position, Toaster, ProgressBar, Intent, Icon } from "@blueprintjs/core"
import { withFormController } from "./FormController"
import CustomDialog from "../Atoms/CustomDialog"
import { useHost } from "../../global/host.global"
import useAuth from "hooks/useAuth"
import CustomButton from "../Atoms/CustomButton"
import ImageCropper from "../Templates/ImageCropper"
import { ErrorToast } from "utils/AppToaster"
const UploadToast = Toaster.create({
  className: "recipe-toaster",
  position: Position.TOP,
})

const FilUploadCrop = ({
  foldername,
  path,
  value,
  onChange,
  label,
  title,
  dialogProps,
  required,
  ...otherProps
}) => {
  const { token } = useAuth()

  const [file, changeFile] = useState({})
  const [croppedFile, setCroppedFile] = useState(null)

  const [isPreviewOpen, togglePreviewDialog] = useState(false)
  const { protocol, host, subdomain } = useHost()
  const link = `${protocol}://${host}/services/uploader/`
  const handleChange = async ({ target: { files } }) => {
    const currentFile = files[0]
    if (currentFile) changeFile(currentFile)
    togglePreviewDialog(true)
  }

  const handleUpload = async () => {
    const form = new FormData()
    form.append("file", croppedFile)
    form.append("path", foldername ? `${subdomain}/${foldername}` : subdomain)

    try {
      const response = await axios.post(link, form, {
        onUploadProgress: ({ total, loaded }) => {
          const progress = loaded / total
          const percentage = Math.floor(progress * 100)
          UploadToast.show(
            {
              icon: "cloud-upload",
              message: (
                <>
                  <small>{croppedFile?.name}</small>
                  <ProgressBar
                    className="vt-file-upload-progress"
                    intent={percentage < 100 ? Intent.PRIMARY : Intent.SUCCESS}
                    value={percentage / 100}
                  />
                </>
              ),

              timeout: percentage < 100 ? 0 : 3000,
            },
            croppedFile?.name
          )
        },

        headers: {
          Tenant: subdomain,
          Authorization: `Bearer ${token}`,
        },
      })

      if (response.data.status === "success") {
        onChange(path, response?.data?.url)
        setCroppedFile(null)
        changeFile({})
        togglePreviewDialog(false)
        AppToaster.show({
          message: (
            <span>
              Image Uploaded Successfully!{" "}
              <a href={response?.data?.url} target="__blank">
                View
              </a>
            </span>
          ),
          intent: "success",
        })
      }
    } catch (err) {
      changeFile({})
      setCroppedFile(null)
      onChange(path, null)
      AppToaster.show({
        message: err.message,
        intent: "danger",
      })
    }
  }
  return (
    <>
      <CustomFileInput
        required={required}
        label={
          <div className="flex items-baseline">
            {label}
            {value && (
              <Icon
                style={{
                  cursor: "pointer",
                }}
                className="ml-2"
                icon="mugshot"
                onClick={e => togglePreviewDialog(true)}
                iconSize={12}
              />
            )}
          </div>
        }
        inputProps={{
          multiple: true,
        }}
        text={file?.name ? file.name : value ? value : "Choose File.."}
        hasSelection={(file && file.name) || value ? true : false}
        onInputChange={handleChange}
        {...otherProps}
      />

      <CustomDialog
        light
        width="70%"
        icon="camera"
        scrollable={false}
        title={title ?? "Preview Photo"}
        isOpen={isPreviewOpen}
        onClose={e => togglePreviewDialog(false)}
        footerRightButton={
          <CustomButton
            dark
            icon="cloud-upload"
            text="Upload File"
            onClick={e => {
              if (file?.name) {
                handleUpload()
              } else {
                ErrorToast("Please upload a valid file")
              }
            }}
          />
        }
        {...dialogProps}
      >
        <ImageCropper
          img={file?.name ? file : value}
          onCrop={croppedFile => setCroppedFile(croppedFile)}
        />
      </CustomDialog>
    </>
  )
}

export default withFormController(FilUploadCrop)
